import CrumbTitle from '@/components/crumbTitle/CrumbTitle';
import { Translation } from '@/hoslog-intl';
import { StoreInformation } from '@/icons';
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/users/store-owners')({
  component: RouteComponent,
  loader: () => {
    return {
      crumb: <CrumbTitle icon={StoreInformation} id="userManagement.crumb.storeOwners" />,
      title: (
        <div className="flex items-center gap-3 font-bold text-page-title">
          <Translation id="userManagement.storeOwners.page.title" />
        </div>
      ),
    };
  },
});

function RouteComponent() {
  return <Outlet />;
}
